import { createFileRoute } from '@tanstack/react-router'
import { ApiTokensPage } from '../features/developer/ApiTokensPage'

export const Route = createFileRoute('/_auth/developer/api-tokens')({
  component: ApiTokensPage,
})
